import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import "../../../assets/svg-icons/ic-close.svg";
import "../../../assets/svg-icons/ic-menu.svg";
import { NavigationLink } from "../../models/navigation-link.model";
import { WindowScrollService } from "../../services/window/window-scroll.service";
import { Link } from "../../ui-library/link/link.model";
import NavigationItems from "./config";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-navigation",
  styleUrls: ["./navigation.component.scss"],
  templateUrl: "./navigation.component.html",
})
export class NavigationComponent implements OnInit, OnDestroy {
  private navigationItems: Link[];
  private activeNavigation: boolean;
  private scrollSubscription: Subscription;
  private scrollVal: number;

  constructor(
    private windowScrollService: WindowScrollService,
  ) { }

  public ngOnInit() {
    this.navigationItems = NavigationItems.map((i) => new Link(i.text, i.link));
    this.scrollSubscription = this.windowScrollService.scrollObservable
      .subscribe((scrolllY: number) => this.scrollVal = scrolllY);
  }

  public ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  private stickyScroll() {
    return this.scrollVal > 100;
  }

  private toggleNavigation() {
    this.activeNavigation = !this.activeNavigation;
  }
}



// WEBPACK FOOTER //
// ./src/app/partials/navigation/navigation.component.ts